import React from 'react';
import { Box } from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { MenuButton } from '@fortress-technology-solutions/fortress-component-library/Molecules';
import messages from '../messages';
import { SUBMIT_SCREENING_MENU_ATTRIBUTE } from '../utils';
import type { Props } from './types';

function SubmitScreeningMenu({
  intl,
  isDisabled,
  isDecisionNeeded,
  options,
  submitTooltipText,
  onResubmit,
  onContinue,
  onStop,
}: Props) {
  const getReasonText = (reason) => {
    if (reason === 'submitTooltip') return submitTooltipText;
    return reason ? intl.formatMessage(reason) : null;
  };

  const items = [
    {
      value: 'resubmit',
      label: messages.menuResubmitScreening,
      option: options.resubmit,
      onClick: onResubmit,
    },
    {
      value: 'continue',
      label: messages.menuContinueScreening,
      option: options.continue,
      onClick: onContinue,
    },
    {
      value: 'stop',
      label: messages.menuStopScreening,
      option: options.stop,
      onClick: onStop,
    },
  ];

  // The MenuButton closes its menu only for a click on one of its options or
  // on its backdrop, not for a click on a child item.
  // An item that opens a modal while the menu stays open breaks that modal:
  // the menu and the modal come from different library bundles, so both
  // focus traps stay active and take focus from the modal's fields.
  const menuOptions = items.map(({ value, label, option }) => ({
    value,
    text: intl.formatMessage(label),
    disabled: option.disabled,
    tooltip: option.disabled ? getReasonText(option.reason) : undefined,
    tooltipProps: { placement: 'left', variant: 'light', arrow: false },
  }));

  const handleMenuItemClick = (value) => {
    const item = items.find((candidate) => candidate.value === value);
    if (item) item.onClick();
  };

  return (
    // The header sits in the accordion summary. The accordion reads this
    // attribute and ignores clicks on the menu, so no click stops here: the
    // MenuButton click-away listener must see every click on the document.
    <Box {...{ [SUBMIT_SCREENING_MENU_ATTRIBUTE]: '' }}>
      <MenuButton
        id="submit-screening-menu"
        variant={isDecisionNeeded ? 'primary' : 'primarySubtle'}
        disabled={isDisabled}
        ButtonProps={{ size: 'small' }}
        options={menuOptions}
        onMenuItemClick={handleMenuItemClick}
      >
        {intl.formatMessage(messages.submitScreening)}
      </MenuButton>
    </Box>
  );
}

export default SubmitScreeningMenu;
